import type { CSSProperties } from 'react';
import Icon from '../ui/Icon';
import { S } from '../../config/theme.js';

interface RenderLangDropdownProps {
  /** Aktuell aktiver Sprach-Code (z.B. 'de'). */
  lang: string;
  setLang: (l: string) => void;
  setLangOpen: (v: boolean) => void;
  /** Liste aller verfügbaren Sprach-Codes (aus `useSettings`). */
  LANGS: readonly string[];
  LANG_FLAGS: Record<string, string>;
  LANG_NAMES: Record<string, string>;
}

/**
 * renderLangDropdown — Sprachauswahl-Dropdown (7 Sprachen) in der Topbar.
 *
 * Positioniert sich absolut unter dem Trigger-Button. Der Caller
 * (AppShell) muss einen `relative`-Container bereitstellen und den
 * `setLangOpen(false)`-Handler an Outside-Clicks binden.
 */
export function renderLangDropdown({
  lang,
  setLang,
  setLangOpen,
  LANGS,
  LANG_FLAGS,
  LANG_NAMES,
}: RenderLangDropdownProps) {
  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 'calc(100% + 6px)',
        right: 0,
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 12,
        boxShadow: '0 8px 32px rgba(0,0,0,.25)',
        overflow: 'hidden',
        minWidth: 160,
        zIndex: 500,
        animation: 'fadeIn .15s ease',
      }}>
      {LANGS.map(function (l) {
        return (
          <button
            key={l}
            onClick={function () {
              setLang(l);
              setLangOpen(false);
            }}
            style={{
              ...(S.row as CSSProperties),
              gap: 10,
              width: '100%',
              padding: '10px 16px',
              border: 'none',
              background: l === lang ? 'rgba(22,163,74,.08)' : 'transparent',
              color: 'var(--text)',
              fontFamily: "'DM Sans',sans-serif",
              fontSize: 13,
              cursor: 'pointer',
              fontWeight: l === lang ? 700 : 400,
              borderLeft: l === lang ? '3px solid var(--accent)' : '3px solid transparent',
            }}>
            <span style={{ fontSize: 18 }}>
              {LANG_FLAGS[l]}
            </span>
            <span>
              {LANG_NAMES[l]}
            </span>
            {l === lang &&
              <span style={{ marginLeft: 'auto', color: 'var(--accent)', fontSize: 12 }}>
                <Icon name="check" size={12} />
              </span>}
          </button>
        );
      })}
    </div>
  );
}
